import { FC } from "react";
import { FormattedMessage } from "react-intl";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog";

import { Button } from "~/components/ui/button";

interface DoclistOutdatedDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onCancel: () => void;
  onUpdate: () => void;
}

export const DoclistOutdatedDialog: FC<DoclistOutdatedDialogProps> = ({
  open,
  setOpen,
  onCancel,
  onUpdate,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            <FormattedMessage
              id="docList.doclistOutdatedDialog.title"
              defaultMessage="Outdated Version Detected"
            />
          </AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          <div className="flex flex-col gap-5">
            <span>
              <FormattedMessage
                id="docList.doclistOutdatedDialog.description1"
                defaultMessage="This version of the doc list is no longer current — it has been updated by someone else."
              />
            </span>
            <span>
              <FormattedMessage
                id="docList.doclistOutdatedDialog.description2"
                defaultMessage="To ensure consistency and avoid breaking changes, you need to update before making any edits."
              />
            </span>
          </div>
        </AlertDialogDescription>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onCancel}>
            <FormattedMessage
              id="docList.doclistOutdatedDialog.cancel"
              defaultMessage="Not now"
            />
          </Button>
          <Button onClick={onUpdate}>
            <FormattedMessage
              id="docList.doclistOutdatedDialog.update"
              defaultMessage="Update"
            />
          </Button>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};
